import Vue from 'vue'
import Vuex from 'vuex'
import 'firebase/auth'
import user from './modules/user'
import app from './modules/app'
import stories from './modules/stories'
import search from './modules/search'

Vue.use(Vuex)

export const vxStore = new Vuex.Store({
	modules: {
		user,
		app,
		stories,
		search,
	},
	// strict: true
})



// WEBPACK FOOTER //
// ./src/store/vuex_store.js